/**
 * Payment plan status ids (AP_Payment.PaymentPlanStatus):
 * 1 = Active, 2 = Canceled, 3 = Complete
 */

export function hasActivePaymentPlan(items = []) {
  if (!Array.isArray(items)) return false;
  return items.some((plan) => Number(plan?.paymentPlanStatusId) === 1);
}

/**
 * @returns {'on_without_active' | 'off_with_active' | null}
 */
export function getPaymentPlanToggleMismatch(flag, items = []) {
  const flagOn = Boolean(flag);
  const hasActive = hasActivePaymentPlan(items);
  if (flagOn && !hasActive) return "on_without_active";
  if (!flagOn && hasActive) return "off_with_active";
  return null;
}

export function getPaymentPlanMismatchMessage(mismatch) {
  if (mismatch === "on_without_active") {
    return "Flag is ON but there is no Active payment plan.";
  }
  if (mismatch === "off_with_active") {
    return "Flag is OFF but an Active payment plan still exists.";
  }
  return null;
}
